import React from 'react';
import { Modal } from 'react-native-web'; // ok aussi en web

const AuthorizationPreviewModal = ({
    visible,
    onClose,
    title,
    bodyText,
}) => {
    if (!visible) return null;

    return (
        <Modal open={visible} onClose={onClose}>
            <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
                {/* overlay */}
                <div
                    className="absolute inset-0"
                    onClick={onClose}
                />

                {/* modal */}
                <div className="relative bg-white rounded-xl max-w-3xl w-full mx-4 p-6 shadow-xl z-10">
                    <div className="flex justify-between items-start mb-4">
                        <h3 className="text-xl font-bold text-black-title">
                            Aperçu – {title}
                        </h3>

                        <button
                            onClick={onClose}
                            className="text-gray-400 hover:text-gray-600 text-lg"
                        >
                            ✕
                        </button>
                    </div>

                    <div className="border rounded-lg p-4 bg-gray-50 max-h-[60vh] overflow-y-auto whitespace-pre-wrap">
                        <p className="text-gray-800">
                            {bodyText}
                        </p>
                    </div>

                    <div className="mt-4 flex justify-end">
                        <button
                            onClick={onClose}
                            className="px-4 py-2 rounded-lg bg-blue-admin text-white font-semibold"
                        >
                            Fermer
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default AuthorizationPreviewModal;
